import { useQuery } from '@tanstack/react-query';
import { subscriptionCancellationApi } from '../api/subscription-cancellation-api';
import { subscriptionCancellationKeys } from '../api/subscription-cancellation-keys';

export function useCancellationSituation() {
  return useQuery<SubscriptionCancellationSituationResponse>({
    queryKey: subscriptionCancellationKeys.situation(),
    queryFn: () => subscriptionCancellationApi.getSituation(),
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}
